"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MEMBER_CHANNEL_UNBAN_OPTIONS = exports.MEMBER_CHANNEL_BAN_OPTIONS = exports.MEMBER_ACCOUNT_UNBAN_OPTIONS = exports.MEMBER_ACCOUNT_BAN_OPTIONS = exports.BAN_ACTION_TYPES = void 0;
var BAN_ACTION_TYPES = {
  FROM_CHANNEL: 'FROM_CHANNEL',
  FROM_ALL_PUBLIC_CHANNELS: 'FROM_ALL_PUBLIC_CHANNELS'
};
exports.BAN_ACTION_TYPES = BAN_ACTION_TYPES;
var MEMBER_CHANNEL_BAN_OPTIONS = [{
  label: '24hr Channel Ban',
  action: BAN_ACTION_TYPES.FROM_CHANNEL,
  timeout: 24 * 60,
  adminOnly: false
}, {
  label: 'Permanent Channel Ban',
  action: BAN_ACTION_TYPES.FROM_CHANNEL,
  adminOnly: true
}];
exports.MEMBER_CHANNEL_BAN_OPTIONS = MEMBER_CHANNEL_BAN_OPTIONS;
var MEMBER_ACCOUNT_BAN_OPTIONS = [{
  label: '24hr Ban for all Public Channels',
  action: BAN_ACTION_TYPES.FROM_ALL_PUBLIC_CHANNELS,
  timeout: 24 * 60,
  adminOnly: true
}, {
  label: 'Permanent Ban for all Public Channels',
  action: BAN_ACTION_TYPES.FROM_ALL_PUBLIC_CHANNELS,
  adminOnly: true
}];
exports.MEMBER_ACCOUNT_BAN_OPTIONS = MEMBER_ACCOUNT_BAN_OPTIONS;
var MEMBER_CHANNEL_UNBAN_OPTIONS = [{
  label: 'Unban from this channel ',
  action: BAN_ACTION_TYPES.FROM_CHANNEL,
  display: function display(member) {
    return member.banned;
  },
  adminOnly: false
}];
exports.MEMBER_CHANNEL_UNBAN_OPTIONS = MEMBER_CHANNEL_UNBAN_OPTIONS;
var MEMBER_ACCOUNT_UNBAN_OPTIONS = [{
  label: 'Unban',
  action: BAN_ACTION_TYPES.FROM_ALL_PUBLIC_CHANNELS,
  display: function display(member) {
    return member.banned;
  },
  adminOnly: true
}];
exports.MEMBER_ACCOUNT_UNBAN_OPTIONS = MEMBER_ACCOUNT_UNBAN_OPTIONS;